<template>
  <a-row :class="[className, 'table-custom']" type="flex">
    <a-col :span="24">
      <a-table
        :showHeader="showHeader"
        description=""
        :rowSelection="
          rowSelection
            ? {
                selectedRowKeys: selectedRowKeys,
                onChange: onSelectChange,
              }
            : null
        "
        :columns="columns"
        :dataSource="dataSource"
        :rowKey="rowKey"
        :loading="loading"
        :expandIconAsCell="expandIconAsCell"
        :expandIconColumnIndex="expandIconColumnIndex"
        :pagination="false"
        :bordered="bordered"
        :scroll="{ x: scrollX ? scrollX : true, y: data.length > 0 ? 600 : 0 }"
        :customRow="customRow"
        class="custom-table"
      >
        <template v-for="col in scopedSlots" :slot="col" slot-scope="text, record, index">
          <slot :name="col" :text="text" :record="record" :index="index"></slot>
        </template>
        <template v-for="col in slots" :slot="col">
          <slot :name="col"></slot>
        </template>
        <template slot="expandIcon" slot-scope="record">
          <slot name="expandIcon" :record="record"></slot>
        </template>
        <!-- <template slot="expandedRowRender" slot-scope="record, index">
          <slot name="expandedRowRender" :slot-scope="{ record, index }"></slot>
        </template> -->
        <template slot="no" slot-scope="text, record, index">
          {{ (page - 1) * size + index + 1 }}
        </template>
        <template slot="action" slot-scope="text, record, index">
          <template v-if="typeAction === 'menu' && actions.length > 0">
            <ButtonDropdown
              typeIcon="more"
              :actions="handleAction(actions, record)"
              @click="(type) => handleClick(type, record, index)"
            />
          </template>
          <template v-else-if="typeAction === 'icon'">
            <a-row type="flex" align="middle" justify="center">
              <a-col v-for="action in actions" :key="action.key" class="action-item">
                <template v-if="checkShowAction(action, handleActionIcon(actions, record))">
                  <Button :icon="action.key" :ghost="true" @click="handleClick(action.value, record, index)" />
                </template>
              </a-col>
            </a-row>
          </template>
        </template>
      </a-table>
    </a-col>
    <a-col :span="24" v-if="pagination" class="pagination">
      <a-row type="flex" :justify="'end'" align="middle">
        <a-col>
          <Pagination
            :page="page"
            :size="size"
            :total="total"
            @handleChangePagination="(payload) => $emit('handleChangePagination', payload)"
          />
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</template>
<script>
import { Remove } from "@/assets";
import { Pagination, Button } from "@/components";
import { mapState } from "vuex";
import {
  BONUS_LEAVE,
  GENERAL_CONFIGURATION,
  handleActionByScreen,
  LEAVE_CARRYOVER_SCREEN,
  PROJECT_LEAVE_DETAIL_SCREEN,
  POLICY_MANAGEMENT_EMPLOYEE_HISTORY_SCREEN,
} from "@/utils";

export default {
  name: "Table",
  components: {
    Button,

    Pagination,
  },
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
    columns: {
      type: Array,
      default: function () {
        return [];
      },
    },
    screen: {
      type: String,
      default: "",
    },
    size: {
      type: Number,
      default: 10,
    },
    page: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: 0,
    },
    rowSelection: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: Boolean,
      default: true,
    },
    expandIconAsCell: {
      type: Boolean,
      default: false,
    },
    expandIconColumnIndex: {
      type: Number,
      default: 0,
    },
    typeAction: {
      type: String,
      default: "icon",
    },
    actions: {
      type: Array,
      default: function () {
        return [];
      },
    },
    slots: {
      type: Array,
      default: function () {
        return [];
      },
    },
    scopedSlots: {
      type: Array,
      default: function () {
        return [];
      },
    },
    rowKey: {
      type: [String, Function],
      default: "id",
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    isDisableScroll: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: "table-custom",
    },
    customRow: {
      type: Function,
    },
    scrollX: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      Remove,
      isShowMultipleActionProcessRequest: false,
      dataSource: this.data ?? [],
    };
  },
  watch: {
    data() {
      this.dataSource = this.data;
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      loading: (state) => state.user.loading,
      timeServer: (state) => state.application.timeServer,
      mostRecentTimeSheetApproved: (state) => state.advance.mostRecentTimeSheetApproved,
    }),
    selectedRowKeys: {
      get: function () {
        return this.$store.state.application.selectedRowKeys;
      },
      set: function (newValue) {
        this.$store.commit("application/SET_SELECTED_ROW_KEYS", newValue);
      },
    },
  },
  mounted() {
    this.handleScroll();
    window.addEventListener("resize", () => this.handleScroll());
    const options = {
      rootMargin: "0px",
      threshold: 1.0,
    };

    var targetNode = document.querySelector(`.${this.className}`);
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          this.dataSource = [...this.data];
        }
      });
    }, options);
    observer.observe(targetNode);
  },
  beforeDestroy() {
    this.$store.commit("application/CLEAR_SELECTED");
    window.removeEventListener("resize", () => this.handleScroll());
  },
  methods: {
    handleActionIcon(actions, record) {
      const { screen, userInfo } = this;
      switch (screen) {
        case BONUS_LEAVE:
        case GENERAL_CONFIGURATION:
        case LEAVE_CARRYOVER_SCREEN:
        case PROJECT_LEAVE_DETAIL_SCREEN: {
          return handleActionByScreen(screen, record, userInfo, actions, this.timeServer);
        }
        case POLICY_MANAGEMENT_EMPLOYEE_HISTORY_SCREEN: {
          return handleActionByScreen(
            screen,
            record,
            userInfo,
            actions,
            this.timeServer,
            this.mostRecentTimeSheetApproved
          );
        }

        default:
          return actions;
      }
    },
    checkShowAction(actionCheck, actions) {
      if (!actionCheck || actions?.length <= 0) return false;
      return actions?.find((action) => action.key === actionCheck.key);
    },
    handleClick(type, data, index) {
      this.$emit("onAction", { type, data, index });
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.$store.commit("application/SET_SELECTED_ROW", { data: selectedRows, from: "multiply" });
      this.$store.commit("application/SET_SELECTED_ROW_KEYS", selectedRowKeys);
      this.$emit("onSelect");
    },
    handleScroll() {
      const { className } = this;
      const css = `.${className ? className : ""} .ant-table .ant-table-body`;
      const bodyTable = document.querySelector(css);
      const contentTable = document.querySelector(`${css} .ant-table-fixed`);
      const dataTable = document.querySelector(`${css} .ant-table-fixed .ant-table-tbody`);

      const header = document.querySelector(`.${className ? className : ""} .ant-table .ant-table-header`);
      if (contentTable?.clientWidth > bodyTable?.clientWidth || dataTable?.clientHeight === 0) {
        // bodyTable.style.marginTop = "0px";
        if (header) {
          header.classList.add("scroll-horizontal");
          header.classList.remove("scroll-not-horizontal");
        }
      } else {
        // bodyTable.style.marginTop = "11px";
        if (header) {
          header.classList.add("scroll-not-horizontal");
          header.classList.remove("scroll-horizontal");
        }
      }
      if (header) {
        if (contentTable?.clientHeight > bodyTable?.clientHeight) {
          header.classList.add("scroll-vertical");
          header.classList.remove("scroll-not-vertical");
        } else {
          header.classList.remove("scroll-vertical");
          header.classList.add("scroll-not-vertical");
        }
      }
    },
  },
  updated() {
    this.handleScroll();
  },
};
</script>

<style lang="scss" scoped>
.table-custom {
  height: 100%;
  max-height: 100%;

  .action-item {
    min-width: 48px;
    min-height: 32px;
  }

  .pagination {
    margin-top: 10px;
  }
}

.background-action {
  background: #f0f2f3;
  padding: 10px 18px;
  border-bottom: 1px solid #d6dbde;
  border-radius: 6px 6px 0 0;
}

.total-item {
  font-weight: 500;
  font-size: 14px;
  color: #29444f !important;
}

::v-deep .custom-table {
  --height-scroll: 10px;
  --width-scroll: 6px;
  &.ant-table-wrapper {
    border: 1px solid #f0f2f3;
    border-radius: 6px;
    .ant-table {
      &.ant-table-scroll-position-left:not(.ant-table-scroll-position-right),
      &.ant-table-scroll-position-right:not(.ant-table-scroll-position-left),
      &.ant-table-scroll-position-middle {
        .ant-table-fixed-right:has(.ant-table-tbody tr) {
          height: calc(100% - var(--height-scroll));
          .ant-table-body-outer {
            padding-top: var(--height-scroll);
          }
        }
        .ant-table-fixed-right:not(.ant-table-tbody tr) {
          height: 100%;
        }
        .ant-table-header {
          //margin-right: var(--width-scroll);
          &.ant-table-hide-scrollbar {
            overflow: auto !important;
          }
        }
        //.ant-table-body {
        // margin-top: var(--height-scroll);
        //}
      }
      &.ant-table-scroll-position-right.ant-table-scroll-position-left {
        .ant-table-body-inner {
          overflow: auto !important;
          margin-top: 0px;
        }
        .ant-table-header {
          //&.scroll-vertical-not-horizontal {
          // margin-right: var(--width-scroll);
          //}
          &.ant-table-hide-scrollbar {
            overflow: hidden !important;
            //margin-right: var(--width-scroll);
          }
        }
        .ant-table-fixed-right {
          .ant-table-body-outer:has(.ant-table-tbody tr) {
            margin-top: var(--height-scroll);
          }
          .ant-table-fixed-header .ant-table-body-inner {
            overflow: auto !important;
          }
        }
      }
      .ant-table-fixed-right {
        .ant-table-body-outer {
          margin-bottom: 0px !important;
          .ant-table-body-inner {
            overflow: auto !important;
          }
        }
      }

      .ant-table-header {
        &.scroll-vertical {
          padding-right: var(--width-scroll);
        }
        &.scroll-not-vertical {
          margin-right: 0px;
        }
        &.scroll-horizontal + .ant-table-body {
          margin-top: 0px;
        }
        &.scroll-not-horizontal + .ant-table-body {
          margin-top: var(--height-scroll);
        }
        .ant-table-thead {
          th {
            vertical-align: text-top;
          }
        }
        &.ant-table-hide-scrollbar {
          margin-bottom: calc(var(--height-scroll) * -1) !important;
          padding-bottom: 0px;
          min-width: var(--height-scroll) !important;
        }
      }

      .ant-table-body-inner {
        background-color: #fff;
      }

      .ant-table-thead {
        th {
          background-color: #f0f2f3;
        }

        .ant-table-column-title {
          font-weight: 700;
          font-size: 13px;
          line-height: 24px;
          color: #4f656f;
        }
      }
      .ant-table-body {
        overflow: auto !important;
        //margin-top: var(--height-scroll);
      }
      .ant-table-tbody {
        .ant-table-row-hover,
        .ant-table-row {
          td {
            background-color: #ffffff;
          }
        }
        &:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
          background-color: #ffffff !important;
        }
      }
      //.ant-table-body-outer {
      //  margin-bottom: -6px !important;
      //}
    }

    th,
    td {
      padding: 10px 14px !important;
      // white-space: pre-wrap;
      //white-space: nowrap;
    }

    td {
      font-weight: 400;
      font-size: 14px;
      color: #29444f;
    }

    .action-item {
      transition: all 0.1s linear;
      &:hover {
        opacity: 0.8;
        transform: scale(1.1);
      }
    }
    ::-webkit-scrollbar {
      height: var(--height-scroll);
      width: 6px;
    }

    ::-webkit-scrollbar-thumb {
      background: rgba(0, 32, 46, 0.62);
      border-radius: 3px;
    }

    ::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: #fff;
    }
  }
}
</style>
